import type { SxProps, Theme } from "@mui/material";

import { theme } from "@/src/theme/theme";

const KATSASTUS_BANNER_CARD_BOX_SHADOW = `0px 0px 40px 0px ${theme.palette.semantic.info.selected}`;

/** Extra horizontal inset inside the desktop card (with theme spacing(3) base padding). */
const KATSASTUS_BANNER_DESKTOP_HORIZONTAL_INSET = "1.5rem";

const katsastusBannerDesktopCardPaddingX = `calc(${theme.spacing(
  3
)} + ${KATSASTUS_BANNER_DESKTOP_HORIZONTAL_INSET})`;

export const katsastusBannerWrapperSx: SxProps<Theme> = {
  mb: 4
};

export const katsastusBannerSectionSx: SxProps<Theme> = {
  py: 3,
  px: [4, 6],
  maxWidth: "lg",
  ml: "auto",
  mr: "auto"
};

export const katsastusBannerCardSx: SxProps<Theme> = {
  border: "1px solid",
  borderColor: theme.palette.semantic.info.dark,
  borderRadius: { xs: 4, md: 10 },
  backgroundColor: theme.palette.background.paper,
  boxShadow: KATSASTUS_BANNER_CARD_BOX_SHADOW,
  px: {
    xs: 3,
    sm: 3,
    lg: katsastusBannerDesktopCardPaddingX
  },
  py: { xs: 4, md: 3 },
  textAlign: { xs: "center", md: "left" },
  overflow: "hidden",
  gap: { xs: 2, md: 3 }
};

export const katsastusBannerTextStackSx: SxProps<Theme> = {
  flex: 1,
  minWidth: 0,
  width: { xs: "100%", md: "auto" },
  alignItems: { xs: "center", md: "flex-start" },
  gap: 1
};

export const katsastusBannerTitleSx: SxProps<Theme> = {
  fontFamily: theme.typography.fontFamily,
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.h3.fontSize,
  lineHeight: 1.3,
  letterSpacing: 0,
  color: theme.palette.brand.katsastus,
  m: 0
};

export const katsastusBannerSubtitleSx: SxProps<Theme> = {
  fontFamily: theme.typography.fontFamily,
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.body1.fontSize,
  lineHeight: 1.5,
  letterSpacing: "0.25px",
  color: theme.palette.brand.katsastus,
  m: 0
};

export const katsastusBannerLogoSx: SxProps<Theme> = {
  width: 61,
  height: 72,
  flexShrink: 0,
  objectFit: "contain",
  display: "block"
};

export const katsastusBannerDesktopLogoWrapperSx: SxProps<Theme> = {
  flexShrink: 0,
  display: { xs: "none", md: "flex" },
  alignItems: "center",
  justifyContent: "center"
};

export const katsastusBannerLogoMobileSx: SxProps<Theme> = {
  width: 102,
  height: 32,
  flexShrink: 0,
  objectFit: "contain",
  display: { xs: "block", md: "none" },
  mt: { xs: 1, md: 0 }
};

export const katsastusBannerCtaButtonSx: SxProps<Theme> = {
  minWidth: 200,
  maxWidth: 300,
  height: 48,
  minHeight: 48,
  py: 0,
  borderRadius: "100px",
  borderWidth: 1,
  boxSizing: "border-box",
  whiteSpace: "nowrap"
};
